/* CarPlay Auto PDP tabs v4  -  specific selector + retries */
(function(){
  'use strict';
  function findDesc(){
    const candidates = document.querySelectorAll('.product__description.rte, .product-information__description');
    for (const el of candidates){
      if (el.children.length >= 4 && el.querySelectorAll('h3').length >= 2) return el;
    }
    return null;
  }
  function buildTabs(){
    const desc = findDesc();
    if(!desc){ window.__cpTabResult = 'no desc with h3s yet'; return; }
    if(desc.dataset.cpTabs === '1' && desc.querySelector('.cp-tabs')) return;
    desc.dataset.cpTabs = '1';
    try {
      const children = Array.from(desc.children);
      const sections = [];
      let current = { title: 'Описание', nodes: [] };
      children.forEach(node => {
        if (node.tagName === 'H3'){
          if (current.nodes.length) sections.push(current);
          let raw = node.textContent.trim().replace(/^[^а-яА-Яa-zA-Z0-9]+/, '').trim();
          current = { title: raw, nodes: [] };
        } else {
          current.nodes.push(node.cloneNode(true));
        }
      });
      if (current.nodes.length) sections.push(current);
      if (sections.length < 2){ window.__cpTabResult = 'sections<2: '+sections.length; desc.dataset.cpTabs=''; desc.classList.add('cp-tabs-settled'); return; }

      sections.forEach(s => {
        s.raw = s.title;
        if (s.title.indexOf('Защо') === 0 || s.title.indexOf('Предимства') === 0 || s.title.indexOf('Важно') === 0) s.title = 'Описание';
        else if (s.title.indexOf('Технически') === 0 || s.title.indexOf('Съдържание') === 0) s.title = 'Спецификации';
        else if (s.title.indexOf('Инсталация') === 0) s.title = 'Инсталация';
        else if (s.title.indexOf('Често') === 0) s.title = 'ЧЗВ';
      });

      const subHead = ['Важно','Съдържание на комплекта'];
      const groups = {}, order = [];
      sections.forEach(s => {
        if (!groups[s.title]){ groups[s.title] = []; order.push(s.title); }
        if (s.raw !== s.title && subHead.indexOf(s.raw) !== -1){
          const h = document.createElement('h4');
          h.textContent = s.raw;
          h.style.cssText = 'margin:22px 0 8px;font-family:\'Roboto Condensed\',sans-serif;font-weight:900;text-transform:uppercase;font-size:14px;letter-spacing:0.04em;';
          groups[s.title].push(h);
        }
        s.nodes.forEach(n => groups[s.title].push(n));
      });

      const priority = ['Описание','Спецификации','Инсталация','Сравнение','ЧЗВ'];
      order.sort((a,b) => {
        const ai = priority.indexOf(a), bi = priority.indexOf(b);
        if (ai === -1 && bi === -1) return 0;
        if (ai === -1) return 1;
        if (bi === -1) return -1;
        return ai - bi;
      });

      const wrap = document.createElement('div');
      wrap.className = 'cp-tabs';
      const nav = document.createElement('div');
      nav.className = 'cp-tabs__nav';
      const panels = document.createElement('div');
      panels.className = 'cp-tabs__panels';

      order.forEach((title, i) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'cp-tabs__btn' + (i===0 ? ' is-active' : '');
        btn.textContent = title;
        btn.dataset.target = 'cpt-' + i;
        nav.appendChild(btn);

        const panel = document.createElement('div');
        panel.className = 'cp-tabs__panel' + (i===0 ? ' is-active' : '');
        panel.id = 'cpt-' + i;
        groups[title].forEach(n => panel.appendChild(n));
        panels.appendChild(panel);
      });

      wrap.appendChild(nav);
      wrap.appendChild(panels);
      while (desc.firstChild) desc.removeChild(desc.firstChild);
      desc.appendChild(wrap);

      nav.addEventListener('click', e => {
        const btn = e.target.closest('.cp-tabs__btn');
        if (!btn) return;
        nav.querySelectorAll('.cp-tabs__btn').forEach(b => b.classList.remove('is-active'));
        panels.querySelectorAll('.cp-tabs__panel').forEach(p => p.classList.remove('is-active'));
        btn.classList.add('is-active');
        document.getElementById(btn.dataset.target).classList.add('is-active');
      });

      window.__cpTabResult = 'OK: ' + order.length + ' tabs';
      desc.classList.add('cp-tabs-settled');
    } catch(e){
      window.__cpTabResult = 'ERROR: ' + e.message;
      desc.dataset.cpTabs = '';
    }
  }
  function init(){ buildTabs(); }
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  setTimeout(init, 300);
  setTimeout(init, 1000);
  setTimeout(init, 2500);
})();
